import { MouseEvent, ReactNode } from 'react';
import { BaseModal, BaseModalContent } from 'src/shared/components/ui/modals/BaseModal';

type ConfirmDeleteProps = {
  children?: ReactNode;
  open: boolean;
  target: string;
  loading?: boolean;
  description?: string;
  disabled?: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: () => void;
};

export default function ConfirmDeleteDialog({
  target,
  open,
  loading,
  children,
  description,
  disabled,
  onOpenChange,
  onDelete,
}: ConfirmDeleteProps) {
  function closeDialog(event: MouseEvent) {
    event.stopPropagation();
    onOpenChange(false);
  }

  function handleDelete(event: MouseEvent) {
    event.stopPropagation();
    onDelete();
    closeDialog(event);
  }

  return (
    <BaseModal open={open} onOpenChange={onOpenChange}>
      <BaseModalContent
        autoClose
        variant="destructive"
        submitLoading={loading}
        onCancel={closeDialog}
        onConfirm={handleDelete}
        confirmDisabled={disabled}
        title={`Are you sure you want to delete ${target}?`}
        subtleTitle="Confirm Deletion"
        description={description || 'This action cannot be undone. Please confirm you want to proceed.'}
      >
        {children}
      </BaseModalContent>
    </BaseModal>
  );
}
